import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const environment = import.meta.env.VITE_ENV ?? 'development';

  // ARCH-019: Sentry is production-only. The `!!dsn` guard means local
  // dev without a DSN never initialises and therefore cannot send events,
  // even if someone sets VITE_ENV=production locally.
  if (!dsn) {
    console.warn('Sentry DSN not configured — error monitoring disabled');
    return;
  }

  Sentry.init({
    dsn,
    environment,
    enabled: environment === 'production',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Strip PII before send: no emails, usernames, or IP addresses.
    // Only user.id (UUID) and role/tenant_id tags survive.
    beforeSend(event) {
      if (event.user) {
        delete event.user.email;
        delete event.user.username;
        delete event.user.ip_address;
      }
      if (event.request) {
        delete event.request.cookies;
        if (event.request.headers) {
          delete event.request.headers.Authorization;
          delete event.request.headers.authorization;
          delete event.request.headers.Cookie;
          delete event.request.headers.cookie;
        }
      }
      return event;
    },
  });
}

export function setSentryUser(params: {
  userId: string;
  role: string | null;
  tenantId: string | null;
}) {
  Sentry.setUser({ id: params.userId });
  if (params.role) Sentry.setTag('user_role', params.role);
  if (params.tenantId) Sentry.setTag('tenant_id', params.tenantId);
}

export function clearSentryUser() {
  Sentry.setUser(null);
  Sentry.setTag('user_role', undefined as unknown as string);
  Sentry.setTag('tenant_id', undefined as unknown as string);
}
